const DEFAULT_MESSAGE =
  "Looks like you are offline. Please check your internet connection, and try again later.";

// The id is the caller's concern: the page-level banner needs one so the
// "online" handler can find it, but the in-panel and sign-in messages must not
// share it.
export default function getOfflineMessage(message = DEFAULT_MESSAGE) {
  let offlineMsgDiv = document.createElement("div");
  // Styling lives in resets.css under .page-banner — there rather than in
  // either page sheet, because core/index.js raises this banner too. It used to be six inline style assignments here, which made
  // this the only component on the page that no stylesheet could reach.
  offlineMsgDiv.className = "page-banner";
  offlineMsgDiv.textContent = message;

  return offlineMsgDiv;
}

// Same message, plus a way out. Used on the paths that have already cleared the
// panel or removed the button by the time they fail, where the only real retry
// is a reload.
export function getRetryMessage(message) {
  const panel = getOfflineMessage(message);

  const retryBtn = document.createElement("button");
  retryBtn.textContent = "Try again";
  retryBtn.addEventListener("click", () => window.location.reload());

  panel.appendChild(document.createElement("br"));
  panel.appendChild(retryBtn);

  return panel;
}
